import Vue from 'vue'
import _ from 'lodash'
import store from '@/store'

const renderComponent = function ({Component, mixins}, data) {
  let el = document.createElement('div')
  el.id = 'created-by-vue-gems'
  document.body.appendChild(el)
  // this is how to add the mixins
  let cloned = _.cloneDeep(Component)
  if (mixins) {
    Component.mixins.push.apply(cloned.mixins, mixins)
  }
  cloned.store = store
  const ExtendedComponent = Vue.extend(cloned)
  const CreatedComponent = new ExtendedComponent({
    el: el,
    ...data
  })
  return CreatedComponent
}

export {
  renderComponent
}



// WEBPACK FOOTER //
// ./src/app/clientLogic/vue/utility.js